import useSWR from 'swr';
import { z } from 'zod';

import { propertiesFormList } from '~/data/generated/endpoints/properties/properties';
import { parseApiResponse } from '~/data/parseApiResponse';
import { propertyFormOptionSchema } from '~/data/schemas/property';

const OTTO_EXAMPLE_PROPERTY_KEY = ['otto', 'examplePropertyName'] as const;

const ottoExamplePropertyNameFetcher = async () => {
  const { data: properties } = await propertiesFormList();
  const parsed = parseApiResponse(
    z.array(propertyFormOptionSchema),
    properties,
    'OttoExamplePropertyName',
  );
  return parsed[0]?.name ?? null;
};

export const useOttoExamplePropertyName = (enabled = true) => {
  const { data, error, isLoading } = useSWR(
    enabled ? OTTO_EXAMPLE_PROPERTY_KEY : null,
    ottoExamplePropertyNameFetcher,
  );

  return { data: data ?? null, error, isLoading };
};
